import { render } from "./RestoreNode.vue?vue&type=template&id=458bf901"
import script from "./RestoreNode.vue?vue&type=script&lang=ts"
export * from "./RestoreNode.vue?vue&type=script&lang=ts"
script.render = render

export default script